import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SettingsProvider } from '@services/settings/settings';

@Injectable()
@Pipe({
	name: 'datepickerFilter'
})
export class DatepickerFilterPipe implements PipeTransform {
	constructor(
		public datePipe: DatePipe,
		private settingsService: SettingsProvider
	) {}

	private dateFormat: string;

	transform(date: string): string {
		this.settingsService.timeFormatSettings.subscribe(data => {
			this.dateFormat = data.dateFormat;
		});

		if (date === 'placeholder') {
			return this.dateFormat === 'DD_MM_YYYY' ? 'dd/mm/yyyy' : 'mm/dd/yyyy';
		}

		return this.dateFormat === 'DD_MM_YYYY'
			? this.datePipe.transform(date, 'dd/MM/yyyy')
			: this.datePipe.transform(date, 'MM/dd/yyyy');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/pipes/datepicker-filter/datepicker-filter.ts